import { css } from '@emotion/react';
import NvDropdown, {
  NvDropdownButtonStyle,
  NvDropdownCheckbox,
  NvDropdownHeader,
  NvDropdownRadio,
} from 'shared/components/inputs/nv-dropdown';

export type NvFilterProps = {
  title: string;
  selected: boolean;
  items: Array<NvDropdownHeader | NvDropdownCheckbox | NvDropdownRadio>;
  onToggle?: (isOpen: boolean) => void;
};

export const NvFilter = ({ title, selected, items, onToggle }: NvFilterProps) => {
  const styles = css`
    .nv-dropdown {
      display: inline-flex;
    }
  `;

  return (
    <div css={styles}>
      <NvDropdown
        showSelectedIndicator
        pill
        title={title}
        altLabel={title}
        buttonStyle={NvDropdownButtonStyle.FORM_SMALL}
        buttonClass={selected && 'selected'}
        items={items}
        menuClassName='filter-menu'
        toggleDataQa={title.split(' ').join('_').toUpperCase()}
        onToggle={onToggle}
      />
    </div>
  );
};

export default NvFilter;
